import { render, staticRenderFns } from "./OsagoPolicy.vue?vue&type=template&id=3eba428c&"
import script from "./OsagoPolicy.vue?vue&type=script&lang=js&"
export * from "./OsagoPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports